import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutDashboard, Search, MessageSquare, PlusCircle, FolderKanban, UserCog } from "lucide-react";
import { SOLUTIONS } from "../../lib/constants";

const NAV = [
  { to: "/conexion",             label: "Inicio",           icon: LayoutDashboard, exact: true },
  { to: "/conexion/buscar",      label: "Buscar",           icon: Search },
  { to: "/conexion/publicar",    label: "Publicar",         icon: PlusCircle },
  { to: "/conexion/mis-publicaciones", label: "Mis publicaciones", icon: FolderKanban },
  { to: "/conexion/mensajes",    label: "Mensajes",         icon: MessageSquare },
  { to: "/conexion/perfil",      label: "Mi perfil",        icon: UserCog },
];

export default function ConexionLayout() {
  const conexion = SOLUTIONS.find((s) => s.id === "conexion");
  const location = useLocation();

  return (
    <div className="px-5 md:px-8 py-6" data-testid="conexion-layout">
      {/* Header del módulo */}
      <section
        className="rounded-3xl overflow-hidden border border-slate-100 shadow-soft bg-white p-6 md:p-8 mb-6"
        style={{ background: `linear-gradient(135deg, #FFFFFF 55%, ${conexion.tint} 100%)` }}
      >
        <div className="flex items-center justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-4 flex-wrap flex-1 min-w-[240px]">
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm border border-slate-100 bg-white p-2 flex-shrink-0" style={{ color: conexion.color }}>
              <conexion.Icon size={30} />
            </div>
            <div className="min-w-[220px]">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: conexion.color }}>
                Pilar 01 · Ecosistema ConstruLink
              </p>
              <h1 className="mt-1 text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
                ConstruLink Red
              </h1>
              <p className="text-sm text-slate-600 mt-1">
                Clientes, maestros-contratistas y ferreterías conectados en una sola plataforma. 🇵🇪
              </p>
            </div>
          </div>
          <div className="relative w-full max-w-xs self-center hidden md:block">
            <div
              aria-hidden
              className="absolute inset-6 rounded-full blur-3xl opacity-40"
              style={{ background: `radial-gradient(circle at 50% 45%, ${conexion.color}66, transparent 70%)` }}
            />
            <img
              src={conexion.iconImage}
              alt="ConstruLink Red"
              className="relative w-full h-40 object-contain drop-shadow-2xl"
              data-testid="conexion-hero-image"
            />
          </div>
        </div>
      </section>

      {/* Sub-navegación */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-soft p-1.5 mb-6 overflow-x-auto cl-scroll-light">
        <nav className="flex items-center gap-1 min-w-max" data-testid="conexion-subnav">
          {NAV.map((item) => {
            const Icon = item.icon;
            const active =
              item.exact
                ? location.pathname === "/conexion" || location.pathname === "/conexion/"
                : location.pathname.startsWith(item.to);
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                data-testid={`conexion-nav-${item.label.toLowerCase().replace(/\s/g, "-").replace("í","i").replace("ó","o")}`}
                className={[
                  "inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors whitespace-nowrap",
                  active
                    ? "bg-brand-blue text-white shadow-sm"
                    : "text-slate-600 hover:text-brand-blue hover:bg-slate-50",
                ].join(" ")}
              >
                <Icon size={16} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
